export class BuildProps {
  static get OrigamiBuildNumber(): string {
    const value = this.value ? this.value.OrigamiBuildNumber : '@origami.build.number@';
    return value && value !== '@origami.build.number@' ? value : '';
  }

  static get OrigamiVersion(): string {
    if (!this.value) {
      return this.value;
    }

    return (this.value.OrigamiBuildNumber || '').split('.').slice(0, 3).join('.');
  }

  static get IntegratedFixes(): string[] {
    return this.value ? this.value.IntegratedFixes : [];
  }

  static get origin(): string {
    return this.value ? this.value.Origin : '../';
  }

  static get HotfixIndex(): number {
    return this.value ? this.value.HotfixIndex || 0 : 0;
  }

  private static value;

  static init(value) {
    this.value = value;
  }
}
